<template>
  <div class="test-qty-page">
    <vx-card-custom :title="formulation ? formulation.formulation_code : ''" no-shadow>
          <template slot="actions">
            <vs-button class="mr-0" color="primary"
                       size="small" type="filled" @click="onClickPrint">Print
            </vs-button>
            <vs-button class="mr-0 ml-2" color="warning"
                       size="small" type="filled" @click="onClickGoBack">Back to formulation
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">

            <div class="vx-row ml-4 mb-8 print:hidden mb-8">
              <div class="vx-col w-1/4">
                <span>Quantity (GRAMS)</span>
                <vs-input v-model="quantity" class="w-full" size=""
                          v-on:input="onInputQty"/>
              </div>
            </div>
            <div id="printDiv">
              <h4 class="mb-4 ml-2">{{ formulation ? formulation.formulation_code : '' }} {{ formulation ? formulation.name : '' }} Breakdown {{ quantity }}
                g</h4>
              <vs-table id="formulation_table" :data="raw_material_items" :hoverFlat="true" class="table-dark-inverted table-auto vs-con-loading__container"
                        noDataText="No raw materials available" sort
                        stripe>

                <template slot="thead">
                  <vs-th class="" sort-key="manufacture_order" width="10%">MON</vs-th>
                  <vs-th class="" width="25%">ITS PROD CODE</vs-th>
                  <vs-th class="" width="25%">PROD NAME</vs-th>
                  <vs-th class="" width="10%">RM STATUS</vs-th>
                  <vs-th class="" width="10%">QUANTITY (GRAMS)</vs-th>
                  <vs-th class="" width="5%">SOL</vs-th>
                  <vs-th class="" width="5%">HALAL</vs-th>
                  <vs-th class="" width="5%">KOSHER</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr v-for="(tr, indextr) in data" :key="indextr">

                    <!-- <vs-td
                      v-if="!(tr.raw_material_items && tr.raw_material_items.length > 0) && isIncludedDilCodedFormulation">
                    </vs-td> -->

                    <vs-td :data="data[indextr].manufacture_order" class="">
                      {{ data[indextr].manufacture_order }}
                    </vs-td>

                    <vs-td :data="data[indextr].company_product_code" class="">

                    <span v-if="tr.formulation_code" class="text-primary" style="cursor: pointer">
                        {{ data[indextr].formulation_code }}
                      </span>
                      <vx-tooltip v-if="tr.company_product_code" position="left" text="View raw material">
                        <span class="text-primary" style="cursor: pointer" @click="onClickLinkToRm(data[indextr].id)">
                          {{ data[indextr].category + ' ' + data[indextr].company_product_code }}
                        </span>
                      </vx-tooltip>
                      <span v-if="tr.code" style="cursor: pointer">
                        {{ data[indextr].code }}
                      </span>
                    </vs-td>
                    <vs-td class="">
                      <span v-if="tr.company_product_name">{{ data[indextr].company_product_name }}</span>
                      <span v-if="tr.name">{{ data[indextr].name }}</span>
                    </vs-td>

                    <vs-td :data="data[indextr].status" class="">
                      <vs-chip class="" color="" size="small" transparent v-if="tr.status">
                        {{ data[indextr].status }}
                      </vs-chip>
                      <vs-chip v-if="tr.is_3rd_party_rm" size="small" transparent class="__table-heading-small" color="danger">
                        RMs from 3rd party
                      </vs-chip>
                    </vs-td>

                    <vs-td :data="data[indextr].quantity" class="">
                      {{ data[indextr].new_qty }}
                    </vs-td>

                    <vs-td :data="data[indextr].dissolvable" class="">
                      {{ data[indextr].dissolvable === 'Yes' ? 'S' : '' }}
                    </vs-td>

                    <vs-td :data="data[indextr].halal_suitable" class="">
                      {{ suitableOrCertified(data[indextr].halal_suitable, data[indextr].halal_certified) }}
                    </vs-td>

                    <vs-td :data="data[indextr].kosher_suitable" class="">
                      {{ suitableOrCertified(data[indextr].kosher_suitable, data[indextr].kosher_certified) }}
                    </vs-td>

                  </vs-tr>

                  <vs-tr>
                    <vs-td colspan="2"></vs-td>
                    <vs-td colspan="2" class="text-center">Total Quantity</vs-td>
                    <vs-td>{{ calTotalNewQuantity() }}</vs-td>
                    <vs-td colspan="3"></vs-td>
                  </vs-tr>


                </template>


              </vs-table>
            </div>
          </div>
        </vx-card-custom>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const FormulationsRepository = RepositoryFactory.get('formulations')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Utils from '@/mixins/Utils'

export default {
  name: "FormulationItemSamplePlay",
  components: {
  },
  data() {
    return {
      formulationId: '',
      formulation: null,
      raw_material_items: [],
      totalQty: null,
      isOnEditMode: false,
      quantity: 100
    }
  },
  props: {
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async refreshData() {
      await this.loadFormulations()
    },
    async onClickLinkToRm(id) {
      this.$router.push({path: `/pages/manage-nimble/suppliers/${id}/raw-material/${id}`})
    },
    async loadFormulations() {
      await this.$vs.loading({
        container: '#formulation_table',
        scale: 0.45
      })
      try {
        const {data} = await FormulationsRepository.details(this.formulationId)
        this.formulation = data.data

        this.spray_dry_carriers = data.data.spray_dry_carriers.map(carrier => {
          carrier.cost = Number(carrier.price)
          carrier.is_3rd_party_rm = true
          return carrier
        })


        if (this.formulation.formulation_items.length > 0) {
          this.raw_material_items = this.formulation.raw_material_items.concat(this.formulation.formulation_items)
        } else {
          this.raw_material_items = this.formulation.raw_material_items
        }
        if(this.formulation.formulation_type === 'spray dry powder' && this.spray_dry_carriers.length > 0) {
          this.raw_material_items = this.raw_material_items.concat(this.spray_dry_carriers)
        }

        this.raw_material_items = this.raw_material_items.map((x) => {
          x.cost = Number(x.cost)
          x.quantity = Number(x.quantity)
          x.new_qty = 0
          return x
        })

        this.raw_material_items = this.raw_material_items.map((n) => {
          n.percentage = ((n.quantity / this.calTotalQuantity()) * 100).toFixed(3)
          return n
        })

        this.raw_material_items = this.raw_material_items.sort((a, b) => {
          if (a.manufacture_order < b.manufacture_order) return -1
          return a.manufacture_order > b.manufacture_order ? 1 : 0
        })
        this.totalQty = this.calTotalQuantity()
        this.onInputQty()
      } catch (e) {

      }
      this.$vs.loading.close('#formulation_table > .con-vs-loading')
    },
    calTotalQuantity() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.quantity)
      })
      return total.toFixed(2)
    },
    calTotalRmCost() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.cost)
      })
      return total.toFixed(2)
    },
    calTotalPerKgCost() {
      return Number(this.calTotalValue() / this.calTotalQuantity()).toFixed(3)
    },
    calTotalValue() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.quantity) * Number(m.cost)
      })
      return total.toFixed(2)
    },
    calTotalPresentage() {
      // let total = 0;
      // this.raw_material_items.forEach((m) => {
      //   total = total + (Number(m.quantity) / Number(this.calTotalQuantity())) * 100
      //   // ((data[indextr].quantity / calTotalQuantity()) * 100)
      // })
      // return total.toFixed(2)

      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.percentage)
        // ((data[indextr].quantity / calTotalQuantity()) * 100)
      })
      return total.toFixed(3)
    },
    suitableOrCertified(suitable, certified) {
      let text = ''
      if (suitable === 'Yes') {
        text = text + ' S'
      }
      if (certified === 'Yes') {
        text = text + ' C'
      }
      return text
    },
    onTestQtyChange(qty) {
      if (Number(qty) > 0) {
        this.raw_material_items = this.raw_material_items.map((n) => {
          n.percentage = ((n.quantity / this.calTotalQuantity()) * 100).toFixed(3)
          return n
        })
      }
    },
    onTestPercentageChange(qty) {
      this.raw_material_items = this.raw_material_items.map((n) => {
        n.quantity = ((n.percentage / 100) * this.totalQty).toFixed(3)
        return n
      })
    },
    onClickPrint() {
      window.print()
      // let printContents = document.getElementById('printDiv').innerHTML;
      // let originalContents = document.body.innerHTML;
      // document.body.innerHTML = printContents;
      // window.print();
      // document.body.innerHTML = originalContents;
    },
    onInputQty() {
      this.raw_material_items = this.raw_material_items.map((n) => {
        n.new_qty = Number(Number(this.quantity) * (Number(n.quantity) / this.calTotalQuantity())).toFixed(3)
        return n
      })
    },
    onClickGoBack() {
      this.$router.push(`/pages/formulations/${this.formulation.id}`)
    },
    calTotalNewQuantity() {
      const total = this.raw_material_items.reduce((a, b) => a + Number(b.new_qty), 0)
      return Number(total).toFixed(0)
    }
  },
  async mounted() {
    this.$emit('setAppClasses', 'test-qty-page')
    this.formulationId = this.$route.params.id
    await this.loadFormulations()
  },
  mixins: [SuccessMessage, ErrorMessages, Utils],
  computed: {
    isIncludedDilCodedFormulation() {
      return this.formulation.formulation_items.length > 0
      // return this.raw_material_items.some((x) => x.formulation_code && x.formulation_code.includes('DIL-'))
    },
    isIncludedCarrierRawMaterial() {
      return this.raw_material_items.some((x) => x.category && x.category === 'CAR')
    },
  }
}
</script>

<style lang="scss">

@media print {
  .test-qty-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
      padding-top: 0;
      margin-top: 0;
    }
  }
}

@page {
  size: A4 portrait;
}
</style>

